import React from "react";
import LottieAnimation from "./lottieAnimation";
import congratulationsCar from "../../assets/images/animations/Congratulations.json";
function CongratsCarImg() {
    return (
        <div className="flex justify-center mx-auto car-img-wrap mb-3 md:mb-6">
            <LottieAnimation
                width={230}
                height={180}
                animationData={congratulationsCar}
            />
        </div>
    );
}

export default CongratsCarImg;
